import { render, staticRenderFns } from "./rights.vue?vue&type=template&id=30d42d62&scoped=true"
import script from "./rights.vue?vue&type=script&lang=ts"
export * from "./rights.vue?vue&type=script&lang=ts"
import style0 from "./rights.vue?vue&type=style&index=0&id=30d42d62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d42d62",
  null
  
)

export default component.exports